import {
  BorderOutlined,
  FieldBinaryOutlined,
  FieldNumberOutlined,
  FieldStringOutlined,
  FieldTimeOutlined,
  FileTextOutlined,
  PushpinOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import { Datatype } from './Datatype.ts';

export interface IDatatypeIconProps {
  type: Datatype;
}

/**
 * Restituisce l'icona corrispondente al tipo di dato.
 */
export function DatatypeIcon(props: IDatatypeIconProps) {
  switch (props.type) {
    case Datatype.Boolean:
      return <FieldBinaryOutlined />;
    case Datatype.Number:
      return <FieldNumberOutlined />;
    case Datatype.String:
      return <FieldStringOutlined />;
    case Datatype.Date:
      return <FieldTimeOutlined />;
    case Datatype.Array:
      return <UnorderedListOutlined />;
    case Datatype.Empty:
      return <BorderOutlined />;
    case Datatype.File:
      return <FileTextOutlined />;
    case Datatype.Map:
      return <PushpinOutlined />;
    default:
      return null;
  }
}
